<template>
  <div class="addOrderRecord">
    <b-container class="bv-example-row px-0">
      <b-row class="mx-0">
        <div class="col-12 px-0">
          <b-row class="mx-0 mb-3">
            <b-col cols="1"> </b-col>

            <b-col cols="10">
              <b-col
                cols="12"
                class="p-0 m-0 mt-4"
                style="font-size: 1.75rem; color: #000000"
              >
                <span class="m-auto">新增完工回報</span>
              </b-col>

              <div class="container" style="margin-top: 2rem">
                <template v-if="page == 1">
                  <div class="col-12 row text-left">
                    <div class="mr-2" style="width: 9rem">
                      <p class style="margin-bottom: 0.625rem">派工單號</p>
                      <b-form-input
                        style="
                              max-width: 9rem;
                              height: 2.375rem;
                              line-height: 1.375rem;
                              font-size: 0.875rem;
                              border: 2px solid rgb(255, 255, 255);
                              box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px 0px;
                              color: rgb(95, 95, 95);
                            "
                        v-model="workID"
                      ></b-form-input>
                    </div>
                    <div class="mr-2" style="width: 9rem">
                      <p class style="margin-bottom: 0.625rem">製程</p>
                      <b-form-select
                        v-model="processSelected"
                        :options="orgProcessOption"
                        class=""
                        style="
                        max-width: 9rem;
                        height: 2.375rem;
                        line-height: 1.375rem;
                        font-size: 0.875rem;
                        border: 2px solid rgb(255, 255, 255);
                        box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px 0px;
                        color: rgb(95, 95, 95);
                      "
                      >
                        <template #first>
                          <b-form-select-option :value="null" disabled
                            >-- 選擇製程 --</b-form-select-option
                          >
                        </template>
                      </b-form-select>
                    </div>
                    <div class="mr-2" style="width: 4.25rem">
                      <b-button
                        class="p-0"
                        @click="queryFoolproof"
                        style="
                        margin-top: 38px;
                        background-color: #4b8c80;
                        width: 4.25rem;
                        height: 2rem;
                        font-size: 1.125rem;
                      "
                        >下一步</b-button
                      >
                    </div>
                  </div>
                </template>
                <template v-if="page == 2">
                  <b-col
                    cols="12"
                    class="text-left mx-0"
                    style="margin-top: 2rem;"
                  >
                    <b-row class="">
                      <b-col cols="12" class="text-left px-0">
                        <div class="d-flex justify-content-end mb-3">
                          <div
                            class="py-1 px-2"
                            style="background: #c8c9ca;min-width: max-content;"
                          >
                            <span>異動人員:{{ changeUserName }}</span>
                          </div>
                        </div>

                        <commonWorkorderTable :workorderItem="workorderItem" />

                        <!-- :category="'add'" -->
                        <sourceRecord
                          :workID="workorderItem[0].work_code"
                          :processID="processID"
                          :sourceData="sourceData"
                          :modStatus="true"
                        />

                        <div class="text-right">
                          <button
                            type="button"
                            class="btn p-0"
                            style="color: #fff;background-color: #4b8c80; width: 6rem; height: 2rem; font-size: 1.125rem;"
                            @click="backStep"
                          >
                            上一步
                          </button>
                          <button
                            type="button"
                            class="btn p-0"
                            style="color: #fff;background-color: #4b8c80; width: 6rem; height: 2rem; font-size: 1.125rem;"
                            @click="checkAdd"
                          >
                            確認新增
                          </button>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </template>
              </div>
            </b-col>

            <b-col cols="1"> </b-col>
          </b-row>
        </div>
      </b-row>

      <modal
        :modalShow="modalShow"
        size="xl"
        headerClass="mes-addOrderRecord-modal-title"
        footerClass="d-none"
      >
        <template v-slot:modalheader style="display:none">
          <button type="button" class="close" @click="toggle_modal()">×</button>
        </template>
        <template v-slot:default>
          <b-row>
            <b-col cols="12" class="px-5 text-center">
              <div>
                <p>
                  {{ modalMsg }}
                </p>
              </div>
              <template v-if="modalConfirm">
                <div>
                  <button
                    type="button"
                    class="btn p-0"
                    style="color: #fff;background-color: #4b8c80; width: 6rem; height: 2rem; font-size: 1.125rem;margin-right: 40px;"
                    @click="toggle_modal()"
                  >
                    取消
                  </button>
                  <button
                    type="button"
                    class="btn p-0"
                    style="color: #fff;background-color: #4b8c80; width: 6rem; height: 2rem; font-size: 1.125rem"
                    @click="
                      toggle_modal(), getWorkorderData(workID, processSelected)
                    "
                  >
                    確認
                  </button>
                </div>
              </template>
              <template v-else>
                <div>
                  <button
                    type="button"
                    class="btn p-0"
                    style="color: #fff;background-color: #4b8c80; width: 6rem; height: 2rem; font-size: 1.125rem"
                    @click="toggle_modal()"
                  >
                    確認
                  </button>
                </div>
              </template>
            </b-col>
          </b-row>
        </template>
      </modal>
    </b-container>
  </div>
</template>

<script>
import sourceRecord from "@/components/orderManagement/sourceRecord.vue";
import commonWorkorderTable from "@/components/orderManagement/table/commonWorkorderTable.vue";
import { mapGetters, mapActions } from "vuex";
import modal from "@/components/modal.vue";
export default {
  name: "addOrderRecord",
  data() {
    return {
      page: 1,
      workID: null,
      processSelected: null,
      processID: null,
      modalShow: false,
      modalMsg: "",
      modalConfirm: false,
      workorderItem: [],
      wireItem: [],
      runcardItem: [],
      totalProduceTimeItem: [],
      sourceData: [],
      changeUser: "",
      changeUserName: ""
    };
  },
  created: function() {},
  mounted: function() {
    let vm = this;
    vm.changeUser = vm.loginData.account;
    vm.changeUserName = vm.loginData.username;
  },
  components: {
    sourceRecord,
    commonWorkorderTable,
    modal
  },
  computed: {
    ...mapGetters({
      axiosResult: "commonaxios/get_axiosResult",
      loginData: "getlogin/get_loginData",
      selectPage: "getlogin/get_selectPage",
      orgProcessOption: "commonqueryiot/get_orgProcessOption"
    })
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      set_alertMsg: "alertmodal/set_alertMsg",
      settimeout_alertModal: "alertmodal/settimeout_alertModal",
      trigger_loadScreenModal: "loadscreenmodal/trigger_loadScreenModal"
    }),
    queryFoolproof() {
      let vm = this;
      let workID = vm.workID;
      let processSelected = vm.processSelected;
      if (workID == "" || workID == null) {
        vm.set_alertMsg("請輸入派工單號");
        vm.settimeout_alertModal();
        return;
      }
      if (processSelected == "" || processSelected == null) {
        vm.set_alertMsg("請選擇製程");
        vm.settimeout_alertModal();
        return;
      }
      vm.reset(["changeUser", "changeUserName", "workID", "processSelected"]);
      vm.nextStep(workID, processSelected);
    },
    nextStep(workID, processSelected) {
      let vm = this;
      var params = {};
      params["vuePage"] = vm.selectPage;
      params["methods"] = "POST";
      params["workID"] = workID;
      params["processSelected"] = processSelected;
      params["whichFunction"] = "selectOrderCheck";
      vm.axiosAction(params).then(() => {
        var result = vm.axiosResult;
        if (result["Response"] == "ok") {
          let this_status = result.QueryTableData;
          let alertMsg = "";
          let modalMsg = "";
          let modalConfirm = false;
          if (processSelected == 5) {
            if (
              this_status == 1 ||
              this_status == 2 ||
              this_status == 3 ||
              this_status == "M" ||
              this_status == "T" ||
              this_status == "N" ||
              this_status == "H"
            ) {
              alertMsg = `${workID}打頭製程已完工，若需調整資料請至修改完工回報`;
            } else if (this_status == "E") {
              modalMsg = `${workID}打頭製程已完工，若為製程重工須補資料請按確認`;
              modalConfirm = true;
            }
          } else if (processSelected == 6) {
            if (this_status == 2 || this_status == "M" || this_status == "H") {
              alertMsg = `${workID}輾牙製程已完工，若需調整資料請至修改完工回報`;
            } else if (
              this_status == "T" ||
              this_status == 3 ||
              this_status == "N"
            ) {
              modalMsg = `${workID}輾牙製程已完工，若為製程重工須補資料請按確認`;
              modalConfirm = true;
            } else if (this_status == 0) {
              modalMsg = `${workID}打頭製程未完工，請先新增打頭製程完工回報資料`;
            }
          } else if (processSelected == 7) {
            if (this_status == 3 || this_status == "N" || this_status == "H") {
              modalMsg = `${workID}熱處理製程已完工，若為製程重工須補資料請按確認`;
              modalConfirm = true;
            } else if (
              this_status == 0 ||
              this_status == 1 ||
              this_status == "E" ||
              this_status == "T"
            ) {
              modalMsg = `${workID}輾牙製程未完工，請先新增輾牙製程完工回報資料`;
            }
          }
          if (alertMsg != "") {
            vm.set_alertMsg(alertMsg);
            vm.settimeout_alertModal();
          } else if (modalMsg != "") {
            vm.modalMsg = modalMsg;
            vm.modalConfirm = modalConfirm;
            vm.toggle_modal();
          }
          if (alertMsg == "" && modalMsg == "") {
            vm.getWorkorderData(workID, processSelected);
          }
        } else {
          if (result["Response"] == "online") {
            let project_name = "-";
            if (result.QueryTableData == "R") {
              project_name = "打頭";
            } else if (result.QueryTableData == "W") {
              project_name = "輾牙";
            } else if (result.QueryTableData == "D") {
              project_name = "熱處理";
            }
            vm.set_alertMsg(
              `${workID}正在${project_name}加工中，欲新增資料請待APP結單`
            );
            vm.settimeout_alertModal();
          } else {
            vm.set_alertMsg(result.Response);
            vm.settimeout_alertModal();
          }
        }
      });
    },
    toggle_modal() {
      let vm = this;
      vm.modalShow = !vm.modalShow;
    },
    getWorkorderData(workID, processSelected) {
      let vm = this;
      vm.trigger_loadScreenModal();
      var params = {};
      params["vuePage"] = vm.selectPage;
      params["methods"] = "POST";
      params["workID"] = workID;
      params["processSelected"] = processSelected;
      params["whichFunction"] = "getWorkorderData";
      vm.axiosAction(params).then(() => {
        vm.trigger_loadScreenModal();
        var result = vm.axiosResult;
        if (result["Response"] == "ok") {
          vm.nextStepGO(result.QueryTableData);
        } else {
          vm.set_alertMsg(result.Response);
          vm.settimeout_alertModal();
        }
      });
    },
    nextStepGO(returnData) {
      let vm = this;
      console.log(returnData);
      let processID = returnData.processSelected;
      let workorderItem = returnData.workorderItem;
      let sourceData = returnData.sourceData;
      vm.workorderItem = workorderItem;
      if (processID == 5) {
        sourceData.forEach(data => {
          data.wireItem.push({
            index: "",
            in_scroll_no: "",
            scroll_no: "",
            orgScroll_no: "",
            code: "",
            chinese_name: "",
            furnaceCode: "",
            in_consumption: "",
            consumption: "",
            orgConsumption: "",
            org_code: "",
            reason: [],
            del: ""
          });
          data.runcardItem.push({
            index: "",
            in_runcard_code: "",
            runcard_code: "",
            orgRuncard_code: "",
            in_furnace_code: "",
            furnace_code: "",
            orgFurnace_code: "",
            in_screw_weight: "",
            screw_weight: "",
            orgScrew_weight: "",
            in_bucket_weight: "",
            bucket_weight: "",
            orgBucket_weight: "",
            reason: [],
            del: ""
          });
        });
      } else if (processID == 6) {
        sourceData.forEach(data => {
          data.runcardItem.push({
            index: "",
            in_runcard_code: "",
            runcard_code: "",
            orgRuncard_code: "",
            in_furnace_code: "",
            furnace_code: "",
            orgFurnace_code: "",
            in_screw_weight: "",
            screw_weight: "",
            orgScrew_weight: "",
            in_bucket_weight: "",
            bucket_weight: "",
            orgBucket_weight: "",
            reason: [],
            del: ""
          });
        });
      } else if (processID == 7) {
        sourceData.forEach(data => {
          data.runcardItem.push({
            index: "",
            in_runcard_code: "",
            runcard_code: "",
            orgRuncard_code: "",
            in_furnace_code: "",
            furnace_code: "",
            orgFurnace_code: "",
            in_screw_weight: "",
            screw_weight: "",
            orgScrew_weight: "",
            in_bucket_weight: "",
            bucket_weight: "",
            orgBucket_weight: "",
            reason: [],
            del: ""
          });
        });
      }
      vm.sourceData = sourceData;
      vm.processID = processID;
      vm.page = 2;
    },
    backStep() {
      let vm = this;
      vm.page = 1;
      vm.reset(["changeUser", "changeUserName", "workID", "processSelected"]);
    },
    checkAdd() {
      let vm = this;
      let addData = [];
      let erro = false;
      vm.sourceData.forEach(data => {
        data.reasonData = "";
        let wireItem = [];
        console.log(data.wireItem);
        if (data.wireItem != undefined) {
          data.wireItem.forEach((wireItemData, index) => {
            if (index == data.wireItem.length - 1) {
              return;
            }
            if (wireItemData.scroll_no == "") {
              erro = true;
              vm.set_alertMsg("線材捲號尚未輸入");
              vm.settimeout_alertModal();
              return;
            }
            if (wireItemData.consumption == "") {
              erro = true;
              vm.set_alertMsg("耗用量尚未輸入");
              vm.settimeout_alertModal();
              return;
            }
            wireItem.push({
              scroll_no: wireItemData.scroll_no,
              code: wireItemData.code,
              chinese_name: wireItemData.chinese_name,
              furnaceCode: wireItemData.furnaceCode,
              consumption: wireItemData.consumption,
              org_code: wireItemData.org_code
            });
          });
          if (erro) {
            return;
          }
        }

        if (data.unit_actual_weight != undefined) {
          if (data.unit_actual_weight == "") {
            erro = true;
            vm.set_alertMsg("單支重尚未輸入");
            vm.settimeout_alertModal();
            return;
          }
        }

        let runcardItem = [];
        console.log(data.runcardItem);
        if (data.runcardItem != undefined) {
          data.runcardItem.forEach((runcardItemData, index) => {
            if (index == data.runcardItem.length - 1) {
              return;
            }
            if (runcardItemData.runcard_code == "") {
              erro = true;
              vm.set_alertMsg("流程卡號尚未輸入");
              vm.settimeout_alertModal();
              return;
            }
            if (runcardItemData.furnace_code == "") {
              erro = true;
              vm.set_alertMsg("爐號尚未輸入");
              vm.settimeout_alertModal();
              return;
            }
            if (runcardItemData.screw_weight == "") {
              erro = true;
              vm.set_alertMsg("重量尚未輸入");
              vm.settimeout_alertModal();
              return;
            }
            if (runcardItemData.bucket_weight == "") {
              erro = true;
              vm.set_alertMsg("桶重尚未輸入");
              vm.settimeout_alertModal();
              return;
            }
            runcardItem.push({
              runcard_code: runcardItemData.runcard_code,
              furnace_code: runcardItemData.furnace_code,
              screw_weight: runcardItemData.screw_weight,
              bucket_weight: runcardItemData.bucket_weight
            });
          });
          if (erro) {
            return;
          }
        }

        let totalProduceTimeItem = [];
        data.totalProduceTimeItem.forEach(totalProduceTimeItemData => {
          if (totalProduceTimeItemData.device_name == "") {
            erro = true;
            vm.set_alertMsg("機台編號尚未輸入");
            vm.settimeout_alertModal();
            return;
          }
          totalProduceTimeItem.push({
            code: totalProduceTimeItemData.code,
            device_name: totalProduceTimeItemData.device_name,
            startTime: totalProduceTimeItemData.startTime,
            endTime: totalProduceTimeItemData.endTime,
            totalTime: totalProduceTimeItemData.totalTime
          });
        });

        if (erro) {
          return;
        }

        addData.push({
          processID: vm.processID,
          workorderBind: data.workorderBind,
          wireItem: wireItem,
          unit_actual_weight: data.unit_actual_weight,
          runcardItem: runcardItem,
          totalProduceTimeItem: totalProduceTimeItem,
          reason: data.reason,
          reasonData: data.reasonData
        });
      });

      if (erro) {
        return;
      }
      vm.trigger_loadScreenModal();
      var params = {};
      params["vuePage"] = vm.selectPage;
      params["methods"] = "POST";
      params["data"] = addData;
      params["changeUser"] = vm.changeUser;
      params["whichFunction"] = "addCompleteOrder";
      vm.axiosAction(params).then(() => {
        vm.trigger_loadScreenModal();
        var result = vm.axiosResult;
        if (result["Response"] == "ok") {
          vm.set_alertMsg(`新增完成`);
          vm.settimeout_alertModal();
          vm.reset(["changeUser", "changeUserName"]);
        } else {
          vm.set_alertMsg(`異常，請再次確認`);
          vm.settimeout_alertModal();
        }
      });
    },
    //資料reset
    reset(keep) {
      var def = this.$options.data();
      for (var i = 0; i < keep.length; i++) {
        def[keep[i]] = this[keep[i]];
      }
      Object.assign(this.$data, def);
      //https://codepen.io/karimcossutti/pen/ObXyKq
    }
  },
  destroyed() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
<style lang="scss">
.mes-addOrderRecord-modal-title {
  background-color: #4b8c80;
  height: 40px;
}
.mes-addOrderRecord-modal-title > button.close {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/addOrderRecord.vue